<template>
  <BModal
    id="modal-delete-log"
    ref="modal-delete-log"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <!-- Close button -->
    <div class="d-flex justify-content-end p-1">
      <button
        class="btn p-0"
        @click="$bvModal.hide('modal-delete-log')"
      >
        <feather-icon
          icon="XIcon"
          size="20"
          class="text-black"
        />
      </button>
    </div>

    <!-- Warning Icon -->
    <div class="text-center">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
        alt="Warning"
        class="m-auto"
        style="max-width: 120px;"
      >
    </div>

    <!-- Question -->
    <h3 class="text-black text-center text-[18px] mt-2 mb-2 leading-normal px-1">
      Kamu yakin ingin menghapus Log ini?
    </h3>

    <!-- Actions -->
    <BRow class="flex justify-center mb-1 px-1">
      <BCol cols="6">
        <b-button
          variant="outline-primary"
          block
          class="rounded-[10px] py-[10px] font-semibold !border-[#FA4F30] !text-[#FA4F30] hover:!bg-[#FFF5F5] bg-white transition-colors duration-200"
          @click="$bvModal.hide('modal-delete-log')"
        >
          Batal
        </b-button>
      </BCol>
      <BCol cols="6">
        <b-button
          :variant="loading ? 'secondary' : 'primary'"
          :disabled="loading"
          block
          class="rounded-[10px] py-[10px] font-semibold !bg-[#FA4F30] !border-0 text-white hover:!bg-[#e04328] transition-colors duration-200"
          @click="onConfirm"
        >
          <BSpinner
            v-if="loading"
            variant="light"
            small
            class="mr-1"
          />
          Hapus
        </b-button>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
/* Local modal overrides if any */
</style>
